import { useRef, useState } from "react";
import { Loader2, ScanBarcode } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

const TONES = { ok: "text-emerald-600 dark:text-emerald-400", warn: "text-amber-600 dark:text-amber-400", muted: "text-muted-foreground" };

export function BarcodeField({ f, setF, onExisting }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const last = useRef(f.barcode || "");
  const running = useRef(false);
  const lookup = async (force) => {
    const code = (f.barcode || "").replace(/\D/g, "");
    if (running.current || !code || (!force && code === last.current)) return;
    running.current = true;
    last.current = code;
    setBusy(true);
    setMsg(null);
    try {
      const { data } = await api.get(`/products/barcode/${code}`, { params: { pid: f.id || "" } });
      if (data.duplicate && !f.id && onExisting) {
        toast.warning(`Este código já é do produto ${data.duplicate.name}. Abrimos o cadastro dele preenchido: ao salvar, você atualiza esse produto.`, { duration: 8000 });
        onExisting(data.duplicate.id);
      } else if (data.duplicate) setMsg({ tone: "warn", text: `Já existe um produto com este código: ${data.duplicate.name}` });
      else if (data.found) {
        setF((x) => {
          const fill = (k) => (data[k] && (!x.id || !x[k]) ? data[k] : x[k]);
          return { ...x, barcode: code, name: fill("name"), description: fill("description"), image_url: fill("image_url") };
        });
        setMsg({ tone: "ok", text: `Encontrado na Open Food Facts: ${data.name}. Confira e complete preço e categoria.` });
      } else setMsg({ tone: "muted", text: data.error || "Produto não encontrado. Preencha os dados manualmente." });
    } catch (e) { setMsg({ tone: "warn", text: errMsg(e) }); }
    running.current = false;
    setBusy(false);
  };
  return (
    <div className="col-span-2 space-y-1.5">
      <Field label="Código de barras" hint="Digite ou passe o leitor. Aceita o código da embalagem ou da etiqueta da loja: busca primeiro nos seus produtos, depois na Open Food Facts">
        <div className="flex gap-2">
          <Input value={f.barcode ?? ""} autoFocus={!f.id} inputMode="numeric" placeholder="Ex.: 7894900011517" onChange={(e) => setF((x) => ({ ...x, barcode: e.target.value }))}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); lookup(true); } }} onBlur={() => lookup(false)} data-testid="product-barcode-input" />
          <Button type="button" variant="outline" onClick={() => lookup(true)} disabled={busy} data-testid="product-barcode-lookup-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ScanBarcode className="h-4 w-4" />}<span className="ml-1">Buscar</span>
          </Button>
        </div>
      </Field>
      {msg && <p className={`text-xs ${TONES[msg.tone]}`} data-testid="product-barcode-status">{msg.text}</p>}
    </div>
  );
}
